import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../theme/ISpcTheme';

export type IFitImageStyleClasses = 'image' | 'variantsImage';

const fitImageStyles = makeStyles<ISpcTheme, { scaleImage: number }, IFitImageStyleClasses>(
  () => ({
    image: {
      maxWidth: '100%',
      maxHeight: '100%',
      transform: ({ scaleImage }) => `translate(-50%, -50%) scale(${scaleImage || 1})`,
      // Either we do like this with important here or we do inline style. Both is bad.
      width: 'unset !important',
      height: 'unset !important',
      left: '50% !important',
      top: '50% !important',
    },
    variantsImage: {},
  }),
  { name: 'SPC_FitImage' },
);

export default fitImageStyles;
